import React from 'react';
import { Input } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { validationClasses } from '@/utils/errors';

const DestinationNamespaceInput = ({
  disabled,
  error,
  onChange,
  value,
}) => {
  const intl = useIntl();
  return (
    <Input
      className={validationClasses(error, 'aridhia-destination-namespace-input')}
      disabled={disabled}
      error={error}
      fluid
      id="select_destination_namespace"
      onChange={(e) => onChange({ destination_namespace: e.target.value })}
      placeholder={intl.formatMessage({ id: 'access.namespace.input.placeholder' })}
      value={value}
    />
  );
};

export default DestinationNamespaceInput;
